<div class="activity-card summary-card summary-card--interactive summary-card--activity">
  <div class="activity-card__wrapper summary-card__wrapper"
     [class.summary-card__wrapper--active]="active"
     (mouseover)="onHover(true)" (mouseleave)="onHover(false)">
    <div class="activity-card__main">
      <h2 class="activity-card__name">{{ activity.name }}</h2>
      <div class="activity-card__rating" *ngIf="activity.rating">
        <span class="activity-card__rating-value">{{ activity.rating }}</span>
        <star-rating class="activity-card__rating-stars" [starType]="'svg'"
                          [rating]="activity.rating" [step]="0.1" [showHalfStars]="true" [staticColor]='"ok"'
                          [readOnly]="true">
        </star-rating>
      </div>
      <div class="activity-card__body">
        <div *ngIf="activity.vicinity" class="activity-card__address">
          {{ activity.vicinity }}
        </div>
      </div>
    </div>
    <div *ngIf="photoUrl" class="activity-card__photo" [style.backgroundImage]="'url('+ photoUrl +')'"></div>
  </div>
</div>
